import { render, staticRenderFns } from "./ImportBase.vue?vue&type=template&id=f97b6820&scoped=true&"
import script from "./ImportBase.vue?vue&type=script&lang=ts&"
export * from "./ImportBase.vue?vue&type=script&lang=ts&"
import style0 from "./ImportBase.vue?vue&type=style&index=0&id=f97b6820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97b6820",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VIcon,VList,VListItem,VListItemGroup})
